import { ZCDLoadingGuard } from '@zencity/common-ui';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { getSatisfactionBarChartData } from 'screens/WidgetGenerator/helpers/questionsScore';
import { ReportBuilderComponentProps } from 'screens/WidgetGenerator/reportGeneratorComponents/components/WidgetWrappers/WidgetWrappers';
import { SurveysReportGeneratorFilterKey } from 'screens/WidgetGenerator/reportGeneratorComponents/enums';
import { ServicesBarChartWidgetWrapper } from 'screens/WidgetGenerator/widgets/ServicesBarChart/ServicesBarChartWidgetWrapper';
import { logger } from 'utils/logger';

export const ServicesBarChartHOC = (props: ReportBuilderComponentProps): ReactElement => {
  const { client, cycles, selectedDateRange, selectedSurveyGroup } = useContext(WidgetGeneratorContext);
  const { params } = props;
  const { filters } = params;

  const fetchServicesBarChartData = async () => {
    const fetchedBarChartData = await getSatisfactionBarChartData({
      client,
      cycles,
      selectedDateRange,
      selectedSurveyGroupId: selectedSurveyGroup.id,
    });
    return fetchedBarChartData;
  };

  const {
    fetchedData: servicesBarChartData,
    isLoading,
    error,
  } = useAsyncEffect(fetchServicesBarChartData, [client, cycles, selectedDateRange]);

  if (error) {
    logger.error(error);
  }

  return (
    <ZCDLoadingGuard loading={isLoading}>
      <ServicesBarChartWidgetWrapper
        replaceClientTokenWith={client.name}
        widgetData={servicesBarChartData ?? []}
        selectedServiceBarAspects={filters?.[SurveysReportGeneratorFilterKey.SELECTED_SERVICE_BAR_ASPECTS]}
        servicesBarChartNumRowsPerTable={filters?.[SurveysReportGeneratorFilterKey.SERVICES_BAR_CHART_NUM_BARS_PER_ROW]}
        tableIndexToDisplay={filters?.[SurveysReportGeneratorFilterKey.SERVICES_BAR_CHART_TABLE_TO_DISPLAY]}
      />
    </ZCDLoadingGuard>
  );
};
